/**
 * Charts
 */

document.addEventListener('DOMContentLoaded', () => {
    var chart = document.getElementById('js-chart-universities');

    if (chart) {
        var chartData = document.querySelector('[data-chart]');
        var labels = JSON.parse(chartData.getAttribute('data-chart'));
        var ctx = document.getElementById('js-chart-universities');

        new Chart(ctx, {
            type: 'pie',
            data: {
                labels: [
                    "Oxbridge - " + labels['oxbridge'] + "%",
                    "Russell Group - " + labels['russellgroup'] + "%",
                    "Other UK - " + labels['otheruk'] + "%",
                    "International - " + labels['international'] + "%"
                ],
                datasets: [{
                    data: [ labels['oxbridge'], labels['russellgroup'], labels['otheruk'], labels['international'] ],
                    backgroundColor: [ "#31CEC9", "#084C61", "#EF6F6C", "#fbdfa2" ],
                    hoverBackgroundColor: [ "#31CEC9", "#084C61", "#EF6F6C", "#fbdfa2" ],
                    borderWidth: 0,
                }]
            },
            options: {
                plugins: {
                    legend: {
                        display: true,
                        position: 'right',
                        labels: {
                            usePointStyle: true,
                            pointStyle: 'rectRounded'
                        }
                    }
                },
                tooltips: {
                    enabled: false
                }
            }
        });
        
        // legend.innerHTML = myPieChart.generateLegend();
    }
});
